var defineWellKnownSymbol = require('../internals/define-well-known-symbol');

// `Symbol.toPrimitive` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.toprimitive
defineWellKnownSymbol('toPrimitive');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.symbol.to-primitive.js
// module id = 1301
// module chunks = 1